/**
 * Router assembly. Shell-owned: RootLayout → (`/l/:slug` LotteryLayout → lotteryRoutes) + routes + dev kit +
 * not-found. Feature agents never edit this file; they append to `src/routes/index.tsx`.
 */
import { createBrowserRouter, createMemoryRouter, type RouteObject } from 'react-router';
import { LotteryLayout } from './layouts/LotteryLayout';
import { RootLayout } from './layouts/RootLayout';
import { lotteryRoutes, routes } from './routes';
import { lazyRoute } from './routes/lazy';
import { notFoundRoutes } from './routes/not-found';

const DevKitPage = lazyRoute(() => import('./routes/dev/DevKitPage'));

export function buildRouteTree(opts: { dev?: boolean } = {}): RouteObject[] {
  const children: RouteObject[] = [
    { path: 'l/:slug', element: <LotteryLayout />, children: lotteryRoutes },
    ...routes,
  ];
  if (opts.dev ?? import.meta.env.DEV) children.push({ path: '/dev/kit', element: <DevKitPage /> });
  children.push(...notFoundRoutes);
  return [{ path: '/', element: <RootLayout />, children }];
}

export function createAppRouter() {
  return createBrowserRouter(buildRouteTree());
}

/** Tests: an in-memory router at a given URL. */
export function createTestRouter(initialEntries: string[], opts: { dev?: boolean } = {}) {
  return createMemoryRouter(buildRouteTree(opts), { initialEntries });
}
